<template>
    <div class="apply--quatation">
        <div class="topName">
            <h3>申请报价</h3>
        </div>
        <div class="quatation__fromBox">
            <div class="title">请填写资料</div>
            <div class="changeProductBox" @click="changeBoxState = true">
                <div class="cell">
                    <div class="fromNmaeBox">
                        <p>选择产品：<span>*</span></p>
                    </div>
                    <div class="iconfont icon-youjiantou"></div>
                </div>
                <div class="changeproductListBox" v-if="changeProduct_List.length >= 1">
                    <div class="productName" v-for="(item, index) in changeProduct_List" :key="index">{{item}}</div>
                </div>
            </div>
            <div class="fromBox">
                <div class="fromCellBox">
                    <div class="fromNmaeBox"> <p>姓名：<span>*</span></p> </div>
                    <div class="inputBox">
                        <div class="leftIcon"> <span class="iconfont icon-xingming1"></span> </div>
                        <div class="right"> <van-field class="quatation__input" v-model="formData.name" placeholder="" /> </div>
                    </div>
                </div>
                <div class="fromCellBox">
                    <div class="fromNmaeBox"> <p>手机：<span>*</span></p> </div>
                    <div class="inputBox">
                        <div class="leftIcon"> <span class="iconfont icon-dianhua"></span> </div>
                        <div class="right"> <van-field class="quatation__input" v-model="formData.mobile" placeholder="" /> </div>
                    </div>
                </div>
                <div class="fromCellBox">
                    <div class="fromNmaeBox"> <p>验证码：<span>*</span></p> </div>
                    <div class="inputBox">
                        <div class="leftIcon"> <span class="iconfont icon-yanzhengyanzhengma"></span> </div>
                        <div class="right" style="flex:1"> <van-field class="quatation__input" v-model="formData.code" placeholder="" /> </div>
                        <button @click="getCode" :disabled='getCodeState' style="font-size:12px">{{ getCodeText }}</button>
                    </div>
                </div>
                <div class="fromCellBox">
                    <div class="fromNmaeBox"> <p>工作单位 ：<span>*</span></p> </div>
                    <div class="inputBox">
                        <div class="leftIcon"> <span class="iconfont icon-gongsi"></span> </div>
                        <div class="right"> <van-field class="quatation__input" v-model="formData.company" placeholder="" /> </div>
                    </div>
                </div>
                <div class="fromCellBox">
                    <div class="fromNmaeBox"> <p>部门/实验室：<span>*</span></p> </div>
                    <div class="inputBox">
                        <div class="leftIcon"> <span class="iconfont icon-shiyanshiyiqi"></span> </div>
                        <div class="right"> <van-field class="quatation__input" v-model="formData.department" placeholder="" /> </div>
                    </div>
                </div>
                <div class="fromCellBox">
                    <div class="fromNmaeBox"> <p>联系地址：<span>*</span></p> </div>
                    <div class="inputBox">
                        <div class="leftIcon"> <span class="iconfont icon-iconfontdizhi"></span> </div>
                        <div class="right"> <van-field class="quatation__input" v-model="formData.address" placeholder="" /> </div>
                    </div>
                </div>
                <div class="fromCellBox">
                    <div class="fromNmaeBox"> <p>电子邮箱：<span>*</span></p> </div>
                    <div class="inputBox">
                        <div class="leftIcon"> <span class="iconfont icon-youjian"></span> </div>
                        <div class="right"> <van-field class="quatation__input" v-model="formData.email" placeholder="" /> </div>
                    </div>
                </div>
                <div class="fromTipsBox"><p>（请确保您填写的个人信息正确）</p></div>
                <div class="fromCellBox fromCellBox__textarea">
                    <div class="textareaBox">
                        <div class="right">
                            <van-field class="quatation__textarea" v-model="formData.desc" type="textarea" placeholder="填写其他需求" />
                        </div>
                    </div>
                </div>
                <div class="item privacy-foo" v-if="privacyform.status == 1">
                    <van-checkbox-group v-model="formData.privacyData">
                        <van-checkbox name="隐私" :checked-color="checkedColor" shape="square" icon-size="16px" style="margin-right:3px"></van-checkbox>
                    </van-checkbox-group>
                    <span style="vertical-align: middle;">{{ privacyform.desc }}</span><span @click="gotoprivacy" style="color: #6cc4da;vertical-align: middle;">《{{ privacyform.title }}》</span>
                </div>

                <div class="fromCellBox fromCellBox__botton">
                    <div class="bottonBox">
                        <van-button class="quatation__button" type="info" @click="submitApply">确定</van-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 产品选择框 -->
        <van-popup v-model="changeBoxState" class="quatation__popup">
            <div class="changeProductBox">
                <div class="title">请选择产品（可多选）</div>
                <div class="productListBox">
                    <van-checkbox-group class="quatation__checkbox" v-model="changeProduct_List" direction="horizontal">
                        <van-checkbox shape="square" v-for="(item, index) in productList" :key="index" :name="item.name"
                            :class="{
                                'quatation__check1': item.width === 1,
                                'quatation__check2': item.width === 2,
                                'quatation__check3': item.width === 3,
                                'quatation__check4': item.width === 4
                            }">
                            {{item.name}}
                        </van-checkbox>
                    </van-checkbox-group>
                </div>
                <div class="fromCellBox__botton">
                    <div class="bottonBox">
                        <van-button class="quatation__button" type="info" @click="sureProduct">确定</van-button>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
// import { hideMenuItems } from '@/libs/wxjssdk'
import { applyQuotation } from '@/api/product'
import { wxShare } from '@/libs/wxjssdk'
import { getPricacy,getOldActivity,getPhoneCode } from '@/api/activity'
export default {
    data () {
        return {
            checkedColor: '#6cc4da', // 单选多选选中的颜色
            privacyform: {},
            cdnUrl: this.$config.baseUrl.cdnUrl,
            changeProduct_List: [],
            formData: {
                product_title: [], // 产品名称
                name: '', // 名字
                mobile: '', // 手机号码
                department: '', // 部门
                company: '', // 单位名称
                address: '', // 地址
                email: '', // 邮箱
                desc: '', // 其他备注
                direct: '', // 直接进入链接
                privacyData: [], // 隐私选中
            },
            changeBoxState: false, // 打开产品选择框
            productList: [
                { name: '移液器', width: 1 }, { name: '移液吸头', width: 2 }, { name: '瓶口分液器和滴定', width: 3 },
                { name: '分液器', width: 1 }, { name: '分液管', width: 2 }, { name: '助吸器', width: 3 },
                { name: '移液管', width: 1 }, { name: '移液工作台', width: 2 }, { name: '温控和混匀仪', width: 3 },
                { name: '离心管', width: 1 }, { name: '工作板', width: 2 }, { name: '离心机', width: 3 },
                { name: '浓缩仪', width: 1 }, { name: 'PCR仪', width: 2 }, { name: 'PCR耗材', width: 3 },
                { name: '核酸蛋白测定仪和分光光度计', width: 4 }, { name: '显微操作', width: 3 },
                { name: '超低温冰箱', width: 4 }, { name: '细胞培养耗材', width: 3 },
                { name: '生物反应器和平行生物反应器', width: 4 }, { name: '摇床', width: 3 },
                { name: '培养箱', width: 4 }, { name: '发酵罐', width: 3 }
            ],
            getCodeText: '获取验证码',
            currentTime: 60,
            getCodeState: false,
        }
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    created () {
        this.direct = location.href.indexOf('direct')
        this.getOldFormdata() // 获取填写过的表单数据(进行默认字段填充)
        // this.formData.name = '测试下'
        // hideMenuItems(['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari'])
    },
    mounted () {
        this.sharePage()
        this.getPricacyList()
    },
    methods: {
        // 获取验证码
        getCode () {
            if(!/^1[23456789]\d{9}$/.test(this.formData.mobile)) {
                this.$toast('请填写正确的手机号')
                return false
            }
            let para = {
                mobile: this.formData.mobile
            }
            getPhoneCode(para).then(res => {
                console.log('获取的验证码',res);
                if (res.errCode != 0) {
                    this.$toast(res.errMsg)
                }
            })
            this.getCodeText= "60秒"
            this.getCodeState = true
            setTimeout(this.getcodeNumber,1000)
        },
        getcodeNumber(){
            let numTime = this.currentTime;
            numTime--;
            this.getCodeText= numTime+"秒"
            this.currentTime = numTime
    
            if (numTime <= 0){
                this.getCodeText= "获取验证码"
                this.getCodeState = false
                this.currentTime= '60'
            }else{
                setTimeout(this.getcodeNumber,1000)
            }
        },
        // 获取填写过的表单数据(进行默认字段填充)
        getOldFormdata () {
            getOldActivity().then(res => {
                console.log('查看下需要填充的数据',res);
                if (res.data) {
                    let para = res.data
                    let fillForm = {
                        name: para.name,
                        email: para.email,
                        mobile: para.mobile
                    }
                    this.formData = fillForm
                    // this.$emit('proList',[fillForm])
                }
                console.log('查看下1111111',this.formData);
            })
        },
        // 获取隐私条款
        getPricacyList () {
            getPricacy().then(res => {
                this.privacyform = res.data
            })
        },
        // 跳转隐私
        gotoprivacy () {
            console.log('去隐私页面',);
            this.$router.push({
                name: 'pricacy',
            })
        },
        submitApply () {
            var verifyPhone = /^1[23456789]\d{9}$/
            if (this.changeProduct_List.length <= 0) {
                this.$toast.fail('请选择产品！')
                return false
            } else if (this.formData.name === '') {
                this.$toast.fail('请输入姓名')
                return false
            } else if (this.formData.mobile === '') {
                this.$toast.fail('请输入手机号码')
                return false
            } else if (!verifyPhone.test(this.formData.mobile)) {
                this.$toast.fail('请输入正确的手机号码')
                return false
            }else if (!this.formData.code) {
                this.$toast.fail('请输入验证码')
                return false
            } else if (this.formData.company === '') {
                this.$toast.fail('请输入单位名称')
                return false
            } else if (this.formData.department === '') {
                this.$toast.fail('请输入部门')
                return false
            } else if (this.formData.address === '') {
                this.$toast.fail('请输入联系地址')
                return false
            } else if (this.formData.email === '') {
                this.$toast.fail('请输入联系邮箱')
                return false
            } else if (this.formData.privacyData.length < 1 && this.privacyform.status == 1) {
                this.$toast('请您勾选隐私条款')
                return false
            }
            this.formData.product_title = JSON.stringify(this.changeProduct_List)
            this.formData.mobile = Number(this.formData.mobile)
            this.formData.openid = this.$store.state.user.openid || 'od1SBuPEYagRA600g6NsY- Bz9LrU'
            this.$toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: 0
            })
            console.log('提交的参数',this.formData);
            applyQuotation(this.formData).then(res => {
                if (res.errCode === 0) {
                    this.$toast.clear()
                    this.$toast.success({
                        message: '提交成功',
                        duration: 1000,
                        onClose: () => {
                            if (this.direct != -1) {
                                this.formData = {}
                                 this.$router.go(0)
                            } else {
                                this.$router.go(-1)
                            }
                            
                        }
                    })
                } else {
                    this.$toast(res.errMsg)
                }
            }).catch(err => {
                this.$toast('提交失败')
                console.log(err)
            })
        },
        sureProduct () { // 选择产品确定按钮
            console.log(this.changeProduct_List)
            if (this.changeProduct_List.length < 1) {
                this.$toast.fail('请您选择产品')
            } else {
                this.changeBoxState = false
            }
        },
        sharePage () {
            var link = window.location.href.split('#')[0]
            const params = {
                title: 'Eppendorf 申请报价', // 分享标题
                desc: 'Eppendorf 申请报价', // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            // console.log('打印参数', params)
            wxShare(params)
        },
        // 单击了搜索结果
        resultEvent (item) {
            console.log(item)
            this.getProductListPort(item)
            this.showSearchKey = false
            this.showResult = true
        }
    }
}
</script>

<style lang="scss">
.privacy-foo {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .apply--quatation {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        background-color: #F7F8FB;
        & > .topName{
            text-align: center;
            color: #6CC5DB;
            font-size: rem(16);
            line-height: rem(22);
            padding-top: rem(18);
            padding-bottom: rem(30);
            & > h3{
                font-weight: normal;
            }
        }
        & > .quatation__fromBox{
            width: 100%;
            padding: 0 rem(20);
            box-sizing: border-box;
            & > .title{
                color: #6CC5DB;
                font-size: rem(16);
                line-height: rem(22);
            }
            .fromNmaeBox{
                font-size: rem(12);
                line-height: rem(17);
                color: #000;
                & > p{
                    & > span{
                        color: #D12727;
                    }
                }
            }
            & > .changeProductBox{
                padding: rem(10) 0;
                border-bottom: 1px solid #E6E6E6;
                & > .cell{
                    display: flex;
                    align-content: center;
                    position: relative;
                    & > .fromNmaeBox{
                        width: 50%;
                    }
                    & > .iconfont{
                        font-size: rem(18);
                        position: absolute;
                        right: 0;
                    }
                }
                & > .changeproductListBox{
                    display: flex;
                    // justify-content: space-between;
                    flex-wrap: wrap;
                    & > .productName{
                        color: #6CC5DB;
                        font-size: rem(12);
                        line-height: rem(14);
                        margin-right: rem(20);
                        margin-top: rem(10);
                    }
                }
            }
            & > .fromBox{
                width: 100%;
                & > .fromCellBox{
                    margin-top: rem(10);
                    &.fromCellBox__botton{
                        margin-top: rem(30);
                    }
                    &.fromCellBox__textarea{
                        margin-top: rem(20);
                    }
                    & > .fromNmaeBox{
                        margin-bottom: rem(5);
                    }
                    .leftIcon{
                        width: rem(36);
                        height: rem(30);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        & > .iconfont{
                            font-size: rem(14);
                            color: #666;
                        }
                        &:after{
                            content: '';
                            display: block;
                            width: 1px;
                            height: rem(20);
                            position: absolute;
                            top: 50%;
                            margin-top: rem(-10);
                            right: 0;
                            background-color: #999999;
                        }
                    }
                    & > .inputBox{
                        width: 100%;
                        height: rem(30);
                        background: rgba(189,189,189,0.15);
                        border-radius: rem(2);
                        display: flex;
                        & > .right{
                            width: 100%;
                            padding: 0 rem(8);
                            box-sizing: border-box;
                            & > .quatation__input.van-cell{
                                width: 100%;
                                height: rem(30);
                                padding: 0;
                                background-color: rgba(0, 0, 0, 0);
                                & > .van-field__value{
                                    & > .van-field__body{
                                        height: 100%;
                                        line-height: rem(30);
                                        color: #333;
                                    }
                                }
                            }
                        }
                    }
                    & > .textareaBox{
                        width: 100%;
                        height: rem(116);
                        background: #EEEFF1;
                        border-radius: rem(4);
                        & > .right{
                            width: 100%;
                            height: 100%;
                            padding: rem(3) rem(6);
                            box-sizing: border-box;
                            & > .quatation__textarea.van-cell{
                                width: 100%;
                                height: 100%;
                                padding: 0;
                                background-color: rgba(0, 0, 0, 0);
                                & > .van-field__value{
                                    & > .van-field__body{
                                        width: 100%;
                                        height: 100%;
                                        color: #333;
                                        background-color: rgba(0, 0, 0, 0);
                                        & > textarea{
                                            width: 100%;
                                            height: 100%;
                                            background-color: rgba(0, 0, 0, 0);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    & > .bottonBox{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-bottom: rem(60);
                        & > .quatation__button.van-button{
                            width: rem(170);
                            height: rem(40);
                            box-sizing: border-box;
                            padding: 0;
                            background: rgba(108,197,219,1);
                            border-radius: rem(4);
                            border: 1px solid rgba(0, 0, 0, 0);
                            font-size: rem(16);
                        }
                    }
                }
                & > .fromTipsBox{
                    margin-top: rem(8);
                    display: flex;
                    justify-content: flex-end;
                    & > p {
                        font-size: rem(12);
                        color: #6CC5DB;
                        line-height: rem(18);
                    }
                }
            }
        }
        .quatation__popup.van-popup.van-popup--center{
            width: 100%;
            height: 100%;
            padding: 0 rem(20);
            transform: none;
            top: 0;
            left: 0;
            & > .changeProductBox{
                width: 100%;
                height: 100%;
                position: relative;
                & > .title{
                    font-size: rem(12);
                    color: #333;
                    line-height: rem(12);
                    padding-top: rem(18);
                }
                & > .productListBox{
                    & > .quatation__checkbox.van-checkbox-group--horizontal{
                        & > .van-checkbox{
                            margin-right: 0;
                            margin-top: rem(18);
                            overflow: visible;
                            &.quatation__check1{
                                width: rem(86);
                                margin-right: 0;
                            }
                            &.quatation__check2{
                                width: rem(110);
                            }
                            &.quatation__check3{
                                width: rem(139);
                            }
                            &.quatation__check4{
                                width: rem(196);
                            }
                            & > .van-checkbox__icon{
                                height: rem(14);
                                font-size: rem(14);
                                line-height: rem(14);
                                & > .van-icon{
                                    width: auto;
                                    height: auto;
                                    line-height: normal;
                                }
                            }
                            & > .van-checkbox__label{
                                font-size: rem(12);
                                line-height: rem(12);
                                margin-left: rem(8);
                                color: #999;
                            }
                        }
                    }
                }
                & > .fromCellBox__botton{
                    position: absolute;
                    width: 100%;
                    bottom: rem(28);
                    & > .bottonBox{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        & > .quatation__button.van-button{
                            width: rem(170);
                            height: rem(40);
                            box-sizing: border-box;
                            padding: 0;
                            background: rgba(108,197,219,1);
                            border-radius: rem(4);
                            border: 1px solid rgba(0, 0, 0, 0);
                            font-size: rem(16);
                        }
                    }
                }
            }
        }
    }
</style>
